
import { Vue, Component, Prop } from 'vue-property-decorator';

import ModalContent from '@/components/modal/ModalContent.vue';
import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';
import UiButton from '@/components/button/ui-button.vue';
import UPDATE_PROJECT_ACTIVITY_TIME from '@/apollo/projectActivities/UpdateProjectActivityTime.gql';
import { Project_Activity_Time } from '@/generated/graphql';

@Component({
	components: {
		ModalContent,
		UiButton,
		ModalFullScreen,
	},
})
export default class DeclineReasonModal extends Vue {
	@Prop({ type: Object, required: true })
	readonly time!: Project_Activity_Time;

	processing: boolean = false;
	declineDisabled: boolean = false;
	reason: string = '';

	async declineTime(): Promise<void> {
		this.processing = true;
		this.declineDisabled = true;

		let id = this.time.id;
		let obj = {
			time: this.time.time,
			status: 'DECLINED',
			notes: this.time.notes,
			tracked_date: this.time.tracked_date,
			reason: this.reason,
		};

		await this.$apollo.mutate({
			mutation: UPDATE_PROJECT_ACTIVITY_TIME,
			variables: {
				id: id,
				obj: obj,
			},
		});

		this.processing = false;
		this.declineDisabled = false;

		this.$emit('closeDeclineModal');
	}

	closeModal(): void {
		this.$emit('closeDeclineModal');
	}
}
